import { render, staticRenderFns } from "./newsgover.vue?vue&type=template&id=2e9d04a3&scoped=true&"
import script from "./newsgover.vue?vue&type=script&lang=js&"
export * from "./newsgover.vue?vue&type=script&lang=js&"
import style0 from "./newsgover.vue?vue&type=style&index=0&id=2e9d04a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d04a3",
  null
  
)

export default component.exports